import React from 'react';
import { Header, Modal } from "semantic-ui-react";


import styled from 'tachyons-components'

// Based on http://tachyons.io/components/footers/small-print/index.html

const BaseFooter = styled('footer')`
  pv4 ph3 ph5-m ph6-l mid-gray
`;

// Links at bottom
const BaseLink = styled('a')`
  f5 dib ph2 link mid-gray dim
`

const LinkList = styled('div')`
  tc mt3
`

const BoldName = styled('span')`
  ttu
  b
`

const SmallText = styled('small')`
  f5 db tc
`

const AboutModal = props => (
  <Modal trigger={props.trigger} size="tiny" closeIcon>
    <Modal.Header>About the RMI Urban Mobility Tool</Modal.Header>
    <Modal.Content>
      <Modal.Description>
        <Header>Team</Header>
        <p>This tool was built with ❤️ for the 🌍 in 2018 by:</p>
        <ul>
          <li>Christine Phan - (RMI) - Summer Research Associate</li>
          <li>Marshall Abramczyk - (RMI) - Senior Associate</li>
          <li>Cameron Yick - Software Engineer</li>
        </ul>
        <p>
          For more information about the RMI's reseach on urban mobility, visit
          the{" "}
          <a
            target="_blank"
            href="https://rmi.org/our-work/global-energy-transitions/india-program/urban-mobility-lab/"
            title="RMI Urban Mobility"
          >
            Urban Mobility Lab website
          </a>
          .
        </p>
      </Modal.Description>
    </Modal.Content>
  </Modal>
);



const Footer = () => (
  <BaseFooter>
    <SmallText>Brought to you by the <BoldName>Rocky Mountain Institute</BoldName></SmallText>
    <LinkList>
      <AboutModal trigger={<BaseLink title="About">About</BaseLink>}/>
      <BaseLink target="_blank" href="https://rmi.org/our-work/global-energy-transitions/india-program/urban-mobility-lab/"    title="RMI Urban Mobility">Urban Mobility Lab</BaseLink>
      <BaseLink href="#"  title="Source Code">Source Code</BaseLink>
    </LinkList>
  </BaseFooter>
)

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer/index.js